import { User as UserFields } from '@/generated/graphql';
import { EditModeComponent } from '@/components/provider/UserCurrentProvider';

export type UserCurrentStorageObject = Pick<UserFields, 'id'> & {
    isEditMode?: EditModeComponent | boolean | undefined;
    isContentEditor?: boolean;
};

const USER_CURRENT_STORAGE_KEY = 'userCurrentStore';

export const getUserCurrentStore = (): UserCurrentStorageObject =>
    JSON.parse(localStorage.getItem(USER_CURRENT_STORAGE_KEY));

export const setUserCurrentStore = (
    userCurrentStorageObject: UserCurrentStorageObject,
) => {
    localStorage.setItem(
        USER_CURRENT_STORAGE_KEY,
        JSON.stringify(userCurrentStorageObject),
    );
    return getUserCurrentStore();
};

export const removeUserCurrentStore = () =>
    localStorage.removeItem(USER_CURRENT_STORAGE_KEY);
